import React from 'react';
import Countdown from 'react-countdown';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ParticipantCard = ({
  participant,
  location,
  status,
  profile,
  currentUserId,
  arrivalTime,
  countdownRenderer,
  onShowEmergencyContact
}) => {
  const getTransportIcon = (method) => {
    const icons = {
      driving: 'Car',
      walking: 'PersonStanding',
      'public-transit': 'Bus',
      bike: 'Bike'
    };
    return icons?.[method] || 'MapPin';
  };

  const getStatusColor = (statusText) => {
    const colors = {
      en_route: 'text-primary',
      arrived: 'text-success',
      delayed: 'text-warning',
      not_started: 'text-muted-foreground'
    };
    return colors?.[statusText] || 'text-muted-foreground';
  };

  const getStatusLabel = (statusText) => {
    const labels = {
      en_route: 'En Route',
      arrived: 'Arrived',
      delayed: 'Delayed',
      not_started: 'Not Started'
    };
    return labels?.[statusText] || statusText;
  };

  return (
    <div className="bg-background border border-border rounded-lg p-4 hover-lift transition-smooth">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name={getTransportIcon(participant?.transportMethod)} size={18} className="text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-foreground truncate">
              {participant?.participantName}
              {participant?.userId === currentUserId && (
                <span className="text-xs text-muted-foreground ml-2">(You)</span>
              )}
            </p>
            <p className="text-xs text-muted-foreground truncate">
              {participant?.participantLocation}
            </p>
          </div>
        </div>
        {location && (
          <div className="flex-shrink-0">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
          </div>
        )}
      </div>

      {status && (
        <div className="mb-3 p-2 bg-muted rounded-lg">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Activity" size={14} className={getStatusColor(status?.status)} />
            <span className={`text-xs font-medium ${getStatusColor(status?.status)}`}>
              {getStatusLabel(status?.status)}
            </span>
          </div>
          {status?.message && (
            <p className="text-xs text-muted-foreground">{status?.message}</p>
          )}
        </div>
      )}

      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-xs text-muted-foreground">Arrival Countdown:</span>
          <Countdown date={arrivalTime} renderer={countdownRenderer} />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-muted-foreground">ETA:</span>
          <span className="text-xs font-medium text-foreground">{participant?.arrivalTime}</span>
        </div>
        {location && (
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">Speed:</span>
            <span className="text-xs font-medium text-foreground">
              {location?.speed ? `${location?.speed?.toFixed(1)} mph` : 'Stationary'}
            </span>
          </div>
        )}
      </div>

      {profile?.emergencyContactName && (
        <div className="mt-3 pt-3 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            iconName="Phone"
            iconPosition="left"
            onClick={onShowEmergencyContact}
            fullWidth
          >
            Emergency Contact
          </Button>
        </div>
      )}
    </div>
  );
};

export default ParticipantCard;